import {useHistory as realUserHistory,useLocation as realUseLocation} from "react-router-dom"
export default function useHistory(...args){
  return realUserHistory.apply(this,args)
  return {
    push:(n)=>{
      alert('to push')
    },
    back:(n)=>{
      alert('to push')
    },
    forward:(n)=>{
      alert('to push')
    }
  }
}

export function useLocation(...args){
  return realUseLocation.apply(this,args)
  return {
    pathname:''
  }
}